<template>
  <base-link :href="source" target="_blank">
    <span :class="$style.icon">
      <question-circle-icon />
    </span>
  </base-link>
</template>

<script>
import BaseLink from 'atoms/base/BaseLink';
import QuestionCircleIcon from 'atoms/icons/notifications/QuestionCircle';

export default {
  name: 'HelpLink',
  components: {
    BaseLink,
    QuestionCircleIcon,
  },
  props: {
    source: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .icon
    display: inline-flex

    path
      fill: rgba(155, 81, 224, 1)
</style>
